"use client";

/**
 * FooterWatermark — the giant faded "askFinz" wordmark at the foot of the footer.
 *
 * "ask" is static. "Finz" periodically fades away and a shark FIN rises from the
 * water (the wordmark's bottom edge) in its place — surfacing white, then
 * deepening to brand red — before "Finz" returns. "ask the shark": the name
 * askFinz, taking on the giants. Loop is pure CSS (see globals.css .footer-fin*),
 * gated by prefers-reduced-motion. The whole mark still fades + rises in once when
 * the footer bottom first scrolls on-screen (motion whileInView).
 *
 * Decorative only (aria-hidden, pointer-events-none, select-none).
 */

import { motion } from "motion/react";

// Shark-fin symbol (single white path, viewBox 0 0 90 80) — used as a CSS mask so
// its colour can be animated white → red independent of the source asset.
const FIN_SRC = "/shared/logos/header/AskFinz_symbol_light.svg";

export function FooterWatermark() {
  return (
    <motion.div
      aria-hidden="true"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.85, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="pointer-events-none relative z-0 mt-6 -mb-[2vw] flex select-none justify-center md:-mt-6 md:-mb-[3vw]"
    >
      <span className="block whitespace-nowrap font-semibold leading-none tracking-tighter text-[22vw]">
        <span className="text-foreground">ask</span>
        {/* Only "Fin" morphs; the "z" stays. */}
        <span className="relative inline-block">
          <span className="footer-fin-word text-[#cc0000]">Fin</span>
          {/* Water-clip sits on the baseline; the fin rises out of it,
              centred over "Fin", white → brand red as it surfaces. */}
          <span className="footer-fin-clip" aria-hidden="true">
            <span
              className="footer-fin"
              style={{
                WebkitMaskImage: `url(${FIN_SRC})`,
                maskImage: `url(${FIN_SRC})`,
              }}
            />
          </span>
        </span>
        <span className="text-[#cc0000]">z</span>
      </span>
    </motion.div>
  );
}
